import { render, staticRenderFns } from "./blog-details.html?vue&type=template&id=18ee50c6&scoped=true&external"
import script from "./blog-details.js?vue&type=script&lang=js&external"
export * from "./blog-details.js?vue&type=script&lang=js&external"
import style0 from "./blog-details.scss?vue&type=style&index=0&id=18ee50c6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ee50c6",
  null
  
)

export default component.exports